/**
 * Folder & Organization Icons
 * 
 * Icons for folder navigation, hierarchies, and file organization.
 * 
 * Used by: Knowledge base, document trees, navigation
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFolder as fadFolder,
  faFolderOpen as fadFolderOpen,
  faFolders as fadFolders,
  faFolderGrid as fadFolderGrid,
  faFolderArrowUp as fadFolderArrowUp,
  faFolderTree as fadFolderTree,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faFolderClosed as fasFolderClosed,
  faFolderTree as fasFolderTree,
  faFolder as fasFolder,
} from "@fortawesome/pro-solid-svg-icons";

export const loadFolderIcons = () => {
  // Duotone folder icons
  library.add(
    fadFolder,
    fadFolderOpen,
    fadFolders,
    fadFolderGrid,
    fadFolderArrowUp,
    fadFolderTree,
  );

  // Solid folder icons
  library.add(
    fasFolderClosed,
    fasFolderTree,
    fasFolder,
  );
};
